module.exports = __webpack_public_path__ + "static/media/ic_document_cloud.563437bf.svg";